import logoE50 from "@assets/events-awards/logo-e50.png";
import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render E50 about page
 */
const E50AboutPage = (): React.ReactElement => {
  return (
    <div data-testid="e50-about-page-component" className="font-public-sans">
      <BlockTitle
        text="About"
        rootClassName="pt-3 mb-6  text-4xl md:text-6xl lg:text-8xl font-medium"
      />

      <p>
        The E50 Awards, established in 1995, seeks to recognise the 50 most
        enterprising local, privately-held companies who have contributed to the
        economic development of Singapore.
      </p>

      <div className="mb-6">
        <img
          src={logoE50}
          alt="Enterprise 50 Awards logo"
          width={250}
          height={227}
        />
      </div>

      <p>
        It is jointly organised by The Business Times and KPMG in Singapore,
        supported by Enterprise Singapore, the Singapore Business Federation and
        the Singapore Exchange, and is sponsored by OCBC Bank.
      </p>

      <p>
        Annually, E50 companies top the headlines with extensive coverage in The
        Business Times and other media. With such valuable endorsement and a
        coveted mark of recognition, E50 companies are the ones to watch in the
        business community.
      </p>
    </div>
  );
};

export default E50AboutPage;
